import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'passFail'})
export class PassFailPipe implements PipeTransform {
    transform(value) {

            return value ? 'Pass' : 'Fail';
        
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/passFail.pipe.ts